import { Address } from "@msuite/ui/address";
import { Email, Link, Phone } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { StatusIndicator } from "@msuite/ui/status-indicator";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { getAddressString, guardString } from "@msuite/utils/strings";
import type { Contact } from "@msuite/utils/types";
import { ContactProjectsIndicator } from "@/components/contacts";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<Contact>();

export const columns = [
	columnHelper.accessor("_type.name", {
		id: "type",
		header: localized("general.type"),
		cell: (cell) =>
			cell.row.original._type ? (
				<div className="h-stack">
					<StatusIndicator color={cell.row.original._type.color} />
					<p>{cell.getValue()}</p>
				</div>
			) : (
				guardString(null)
			),
	}),
	columnHelper.accessor("name", {
		id: "name",
		header: localized("contacts.fields.name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor((row) => getAddressString(row), {
		id: "address",
		header: localized("address.address"),
		cell: (cell) => <Address item={cell.row.original} />,
	}),
	columnHelper.accessor("email", {
		header: localized("personnel.fields.email"),
		id: "email",
		cell: (cell) => <Email>{guardString(cell.getValue())}</Email>,
	}),
	columnHelper.accessor("phone", {
		header: localized("personnel.fields.phone"),
		id: "phone",
		cell: (cell) => <Phone>{guardString(cell.getValue())}</Phone>,
	}),
	columnHelper.accessor((row) => row._projects.map((project) => project.name).join(", "), {
		id: "projects",
		header: localized("projects.projects"),
		cell: (cell) => <ContactProjectsIndicator projects={cell.row.original._projects} />,
		sortFn: (a, b) => {
			return b.original._projects.length - a.original._projects.length;
		},
	}),
	columnHelper.accessor((row) => row._relatedContact?.name, {
		id: "relatedContact",
		header: localized("contacts.superior_contact"),
		cell: (cell) =>
			cell.row.original._relatedContact?.id ? (
				<Link href={`/contacts/${cell.row.original._relatedContact?.id}`}>
					{guardString(cell.getValue())}
				</Link>
			) : (
				guardString(null)
			),
	}),
	createRowActions(RowActions),
];
